// extracted by mini-css-extract-plugin
export var intro = "person-module--intro--iiWhw";
export var person = "person-module--person--kD9vV";